import { Target } from '@nirvana/shared/dtos/types/dashboards/common';
import { ReportingPeriod } from '@nirvana/shared/dtos/types/shared/time';
import { BaseAdaptableWebComponent } from '../framework/BaseAdaptableWebComponent';

export class BaseWidgetWebComponent extends BaseAdaptableWebComponent {
  get dashboardId(): string {
    const value = this.getAttribute('data-dashboard-id');
    return value ? value : '';
  }

  set dashboardId(value: string) {
    this.setAttribute('data-dashboard-id', value);
  }

  get widgetId(): string {
    const value = this.getAttribute('data-widget-id');
    return value ? value : '';
  }

  set widgetId(value: string) {
    this.setAttribute('data-widget-id', value);
  }

  get widgetType(): string {
    const value = this.getAttribute('data-widget-type');
    return value ? value : '';
  }

  set widgetType(value: string) {
    this.setAttribute('data-widget-type', value);
  }

  set targets(value: Array<Target>) {
    this.setAttribute('data-targets', JSON.stringify(value));
  }

  get targets(): Array<Target> {
    const value = this.getAttribute('data-targets');
    return value ? JSON.parse(value) : [];
  }

  get reportingPeriod(): ReportingPeriod {
    const value = this.getAttribute('data-reporting-period');
    return value ? JSON.parse(value) : null;
  }

  set reportingPeriod(value: ReportingPeriod) {
    this.setAttribute('data-reporting-period', JSON.stringify(value));
  }

  set canDrillDown(value: boolean) {
    if (!value) {
      return;
    }
    this.setAttribute('data-can-drill-down', JSON.stringify(value));
  }

  get canDrillDown(): boolean {
    const value = this.getAttribute('data-can-drill-down');
    return value ? JSON.parse(value) : false;
  }
}
